import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { cn } from "@/lib/utils";
import { Slash } from "lucide-react";
import type { ReactNode } from "react";
import React, { Fragment } from "react";

interface PageTitleProps {
  location: string[];
  children?: ReactNode;
}

export default function PageTitle({ location, children }: PageTitleProps) {
  return (
    <div className="border-b border-[#E7E7EE] h-[70px] flex items-center justify-between px-4">
      <Breadcrumb className="flex-1 py-2">
        <BreadcrumbList>
          {location.filter(Boolean).map((item, index) => (
            <Fragment key={`${item}-${index}`}>
              <BreadcrumbItem>
                <BreadcrumbPage
                  className={cn(
                    "text-lg font-semibold capitalize",
                    index === location.length - 1 && "font-bold",
                  )}
                >
                  {item}
                </BreadcrumbPage>
              </BreadcrumbItem>
              {index < location.length - 1 && (
                <BreadcrumbSeparator>
                  <Slash size={16} />
                </BreadcrumbSeparator>
              )}
            </Fragment>
          ))}
        </BreadcrumbList>
      </Breadcrumb>
      {children}
    </div>
  );
}
